// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgShower2 = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.786 5.416c.027.15.072.35.15.582.192.575.584 1.368 1.39 2.175.808.807 1.6 1.199 2.176 1.391a4.178 4.178 0 0 0 .582.15 3.057 3.057 0 0 0-4.298-4.298Zm6.31 1.212A4.558 4.558 0 0 0 3.47 4.585a.75.75 0 0 0-.22.53H4h-.75v.045l.005.086c.005.07.014.166.03.284.034.235.1.56.228.943.257.77.764 1.771 1.753 2.76.99.99 1.99 1.497 2.76 1.754.187.062.36.11.515.146l8.108 5.97a.75.75 0 0 0 1.078-.201l.086-.136a2.826 2.826 0 0 0-.328-3.443l-6.39-6.695Zm.036 2.211a4.528 4.528 0 0 1-.818 1.737l6.435 4.738c.015-.349-.106-.7-.35-.956m0 0L11.133 8.84l5.268 5.52ZM3 9.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0V10A.75.75 0 0 1 3 9.25Zm2 2a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0V12a.75.75 0 0 1 .75-.75Zm-2 2a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0V14a.75.75 0 0 1 .75-.75Zm4 0a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0V14a.75.75 0 0 1 .75-.75Zm-2 2a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0V16a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
)

export default SvgShower2
